import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=571bbcf0&scoped=true"
import script from "./DetailModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=571bbcf0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "571bbcf0",
  null
  
)

export default component.exports